<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import { opcoesSexo, opcoesEstadoCivil, opcoesRegimeDeBens } from '@/libs/constants/proprietario'
import moment from 'moment'

export default {
  components: {
    Label,
    AppDisplay
  },
  props: {
    proprietario: {
      type: Object
    }
  },
  data () {
    return {
      opcoesSexo,
      opcoesEstadoCivil,
      opcoesRegimeDeBens
    }
  },
  methods: {
    formataSexo (sexo) {
      if (!sexo) return ''
      return this.opcoesSexo.find(opcao => opcao.id === sexo).nome
    },
    formataDataNascimento (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formataEstadoCivil (estadoCivil) {
      if (!estadoCivil) return ''
      return this.opcoesEstadoCivil.find(opcao => opcao.id === estadoCivil).nome
    },
    formataRendaFamiliar (rendaFamiliar) {
      if (!rendaFamiliar) return ''
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(rendaFamiliar)
    },
    formataRegimeDeBens (regimeBens) {
      if (!regimeBens) return ''
      return this.opcoesRegimeDeBens.find(opcao => opcao.id === regimeBens).nome
    },
    formataMunicipioUF (municipio) {
      if (!municipio.nome || !municipio.codigoEstado) return ''
      return `${municipio.nome}/${municipio.codigoEstado}`
    }
  }
}

</script>

<template>
  <div>
    <div>
      <span class="title-proprietario">Dados do proprietário</span>
      <hr />
    </div>
    <div v-if="proprietario.pessoa.pessoaFisica && proprietario.pessoa.pessoaFisica.cpf">
      <el-row>
        <el-col :span="12">
          <app-display label="Nome completo:" :content="proprietario.pessoa.pessoaFisica.nome" />
          <app-display label="CPF:" :content="proprietario.pessoa.pessoaFisica.cpf" />
          <app-display label="RG:" :content="proprietario.pessoa.pessoaFisica.rg" />
          <app-display label="Sexo:" :content="formataSexo(proprietario.pessoa.pessoaFisica.sexo)" />
          <app-display label="Data de nascimento:" :content="formataDataNascimento(proprietario.pessoa.pessoaFisica.dataNascimento)" />
        </el-col>
        <el-col :span="12">
          <app-display label="Município/UF de naturalidade:" :content="proprietario.pessoa.pessoaFisica.naturalidade ? proprietario.pessoa.pessoaFisica.naturalidade.nome + '/' + proprietario.pessoa.pessoaFisica.naturalidade.codigoEstado : ''" />
          <app-display label="E-mail(s):" :content="proprietario.pessoa.emails.length ? proprietario.pessoa.emails.map(e => e.dado).join(', ') : ''" />
          <app-display label="Telefone(s):" :content="proprietario.pessoa.telefones.length ? proprietario.pessoa.telefones.map(t => t.numero).join(', ') : ''" />
          <app-display label="Estado civil:" :content="formataEstadoCivil(proprietario.pessoa.pessoaFisica.estadoCivil)" />
          <app-display label="Renda familiar:" :content="formataRendaFamiliar(proprietario.pessoa.pessoaFisica.rendaFamiliar)" />
        </el-col>
      </el-row>
      <div v-if="proprietario.conjuge && proprietario.conjuge.pessoaFisica.cpf && (proprietario.pessoa.pessoaFisica.estadoCivil === 'CASADO' || proprietario.pessoa.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL')" class="mt-2">
        <div>
          <span class="title-proprietario">Dados do cônjuge</span>
          <hr />
        </div>
        <el-row>
          <el-col :span="12">
            <app-display label="Regime de bens:" :content="formataRegimeDeBens(proprietario.conjuge.pessoaFisica.regimeBens)" />
            <app-display label="Nome completo:" :content="proprietario.conjuge.pessoaFisica.nome" />
          </el-col>
          <el-col :span="12">
            <app-display label="CPF:" :content="proprietario.conjuge.pessoaFisica.cpf" />
            <app-display label="Sexo:" :content="formataSexo(proprietario.conjuge.pessoaFisica.sexo)" />
            <app-display label="Município/UF de naturalidade:" :content="proprietario.conjuge.pessoaFisica.naturalidade ? proprietario.conjuge.pessoaFisica.naturalidade.nome + '/' + proprietario.conjuge.pessoaFisica.naturalidade.codigoEstado : ''" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-else>
      <el-row>
        <el-col :span="12">
          <app-display label="Razão social:" :content="proprietario.pessoa.pessoaJuridica.razaoSocial" />
          <app-display label="Nome fantasia:" :content="proprietario.pessoa.pessoaJuridica.nomeFantasia" />
          <app-display label="CNPJ:" :content="proprietario.pessoa.pessoaJuridica.cnpj" />
          <app-display label="Inscrição estadual:" :content="proprietario.pessoa.pessoaJuridica.inscricaoEstadual" />
          <app-display label="Código CNAE (subclasse):" :content="proprietario.pessoa.pessoaJuridica.cnae.codigo" />
        </el-col>
        <el-col :span="12">
          <app-display label="Nome da atividade conforme CNAE:" :content="proprietario.pessoa.pessoaJuridica.cnae.nomeAtividade" />
          <app-display label="Ramo de atuação:" :content="proprietario.pessoa.pessoaJuridica.ramoAtuacao" />
          <app-display label="E-mail(s):" :content="proprietario.pessoa.emails.length ? proprietario.pessoa.emails.map(e => e.dado).join(', ') : null" />
          <app-display label="Telefone(s):" :content="proprietario.pessoa.telefones.length ? proprietario.pessoa.telefones.map(t => t.numero).join(', ') : null" />
        </el-col>
      </el-row>
    </div>
    <div class="mt-2">
      <span class="title-proprietario">Endereço de correspondência</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="CEP:" :content="proprietario.pessoa.enderecoCorrespondencia.cep" />
        <app-display label="Logradouro:" :content="proprietario.pessoa.enderecoCorrespondencia.logradouro" />
        <app-display label="Número:" :content="proprietario.pessoa.enderecoCorrespondencia.numero" />
      </el-col>
      <el-col :span="12">
        <app-display label="Complemento:" :content="proprietario.pessoa.enderecoCorrespondencia.complemento || proprietario.pessoa.enderecoCorrespondencia.comunidadeLocalidade" />
        <app-display label="Bairro:" :content="proprietario.pessoa.enderecoCorrespondencia.bairro" />
        <app-display label="Município/UF:" :content="proprietario.pessoa.enderecoCorrespondencia.municipio ? formataMunicipioUF(proprietario.pessoa.enderecoCorrespondencia.municipio) : ''" />
      </el-col>
    </el-row>
  </div>

</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Proprietario/Proprietario.vue